import type { RequestConfig } from '@customTypes/index';
import type { ClubItem, PaginatedResponse } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type GetClubsActivityList = {
  pageNumber: string;
};

export type GetClubsActivityListParams = RequestConfig;

export const getClubsActivityList = async ({
  config
}: GetClubsActivityListParams) =>
  api.get<PaginatedResponse<ClubItem[]>>(
    `/api/UserActivities/all-clubs`,
    config
  );
